<template>
  <div :class="[multipage === true ? 'multi-page' : 'single-page', 'home-page']">
    <img v-if="level > 3"
         alt=""
         class="u-title"
         style="width:100%"
         src="../assets/images/home-img/home-village.jpg" />
    <a-carousel arrows
                :dots="false"
                class="scorll-row">
      <div slot="prevArrow"
           slot-scope="props"
           class="custom-slick-arrow"
           style="left: 10px;zIndex: 1">
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow"
           slot-scope="props"
           class="custom-slick-arrow"
           style="right: 10px">
        <a-icon type="right-circle" />
      </div>
      <div>
        <a-row :gutter="8"
               class="count-info"
               v-if="level <= 3"
               style="">
          <a-col :lg="6"
                 :md="12"
                 :sm="24">
            <a-card class="white-card">
              <div class="left-content">
                <div>
                  <span class="round-bg round-bg1">投保总户数(户)</span>
                  <span v-if="topItem.length > 0"
                        style="color:rgba(26, 141, 238, 1)">{{ sumItem.personCount || 0 }}</span>
                  <span v-else>0</span>
                </div>
                <div>
                  <span class="round-bg round-bg1">投保总面积(亩)</span>
                  <span v-if="topItem.length > 0"
                        style="color:rgba(26, 141, 238, 1)">{{ sumItem.cbAcreage || 0 }}</span>
                  <span v-else>0</span>
                </div>
              </div>
              <div class="right-content"><img alt="logo"
                     class="u-title"
                     src="../assets/images/home-img/icon-chart.png" /></div>
            </a-card>
          </a-col>
          <a-col :lg="6"
                 :md="12"
                 :sm="24"
                 v-for="(item, index) in topItem1"
                 v-if="index < 3"
                 :key="index">
            <a-card class="white-card">
              <div class="left-content">
                <div>
                  <span :class="dynamicStateRoundBg(index)"
                        style="font-size:15px;">{{ item.plantTypeName }}</span>
                </div>
                <div>
                  <span style="color:#333">投保户数(户)</span>
                  <span :class="dynamicStateClassName(index)"
                        v-if="topItem.length > 0">{{ item.personCount || 0 }}</span>
                  <span :class="dynamicStateClassName(index)"
                        v-else>0</span>
                </div>
                <div>
                  <span style="color:#333">投保面积(亩)</span>
                  <span :class="dynamicStateClassName(index)"
                        v-if="topItem.length > 0">{{ item.cbAcreage || 0 }}</span>
                  <span :class="dynamicStateClassName(index)"
                        v-else>0</span>
                </div>
              </div>
              <!-- <div class="right-content"><img alt="logo" class="u-title" src="../assets/images/home-img/icon-rice.png" /></div> -->
              <div class="right-content"><img alt="logo"
                     class="u-title"
                     :src="dynamicStateImg(index)" /></div>
            </a-card>
          </a-col>

        </a-row>
      </div>
      <div v-for="(m, i) in topItem2.length"
           :key="i">
        <a-row :gutter="8"
               class="count-info"
               v-if="level <= 3"
               style="">
          <a-col :lg="6"
                 :md="12"
                 :sm="24"
                 v-for="(item, index) in topItem2[i]"
                 :key="index">
            <a-card class="white-card">
              <div class="left-content">
                <div>
                  <span :class="dynamicStateRoundBg(index + 3)"
                        style="font-size:15px;">{{ item.plantTypeName }}</span>
                </div>
                <div>
                  <span style="color:#333">投保户数(户)</span>
                  <span :class="dynamicStateClassName(index + 3)"
                        v-if="topItem.length > 0">{{ item.personCount || 0 }}</span>
                  <span :class="dynamicStateClassName(index + 3)"
                        v-else>0</span>
                </div>
                <div>
                  <span style="color:#333">投保面积(亩)</span>
                  <span :class="dynamicStateClassName(index + 3)"
                        v-if="topItem.length > 0">{{ item.cbAcreage || 0 }}</span>
                  <span :class="dynamicStateClassName(index + 3)"
                        v-else>0</span>
                </div>
              </div>
              <div class="right-content"><img alt="logo"
                     class="u-title"
                     :src="dynamicStateImg(index + 3)" /></div>
            </a-card>
          </a-col>
        </a-row>
      </div>

    </a-carousel>

    <div v-if="level <= 3">
      <a-row :gutter="8"
             class="count-info">
        <a-col :lg="6"
               :md="12"
               :sm="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各险种投保面积占比(%)</div>
            <AreaPercentageChart ref="areaPercentageChart"
                                 :id="'areaPercentageChart'" />
          </a-card>
        </a-col>
        <a-col :lg="6"
               :md="12"
               :sm="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">政策保险完成比例(%)</div>
            <CompleteRateChart ref="completeRateChart1"
                               :id="'completeRateChart1'" />
          </a-card>
        </a-col>
        <a-col :lg="12"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">全省历年投保情况分析(亩)</div>
            <ProvinceInsuredChart ref="provinceInsuredChart"
                                  :id="'provinceInsuredChart'" />
          </a-card>
        </a-col>
      </a-row>

      <a-row :gutter="8"
             class="count-info">
        <a-col :lg="12"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各地市投保情况排名</div>
            <CityInsuranceChart ref="cityInsuranceChart"
                                :id="'cityInsuranceChart'" />
          </a-card>
        </a-col>
        <a-col :lg="12"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各保险公司三年承保情况(亩)</div>
            <ThreeYearAreasChart ref="threeYearAreasChart"
                                 :id="'threeYearAreasChart'" />
          </a-card>
        </a-col>
      </a-row>

      <a-row :gutter="8"
             class="count-info">
        <a-col :lg="24"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title"
                 style="margin-bottom:0">黑龙江省各区县投保情况</div>

            <a-col :lg="11"
                   :md="24"
                   class="visit-count-wrapper">
              <MapChart @mapChartFun="handleMapChartClick"
                        :id="'mapId'" />
            </a-col>
            <a-col :lg="13"
                   :md="24"
                   class="visit-count-wrapper part-2">
              <!-- <a-row :gutter="8"
                   class="count-info" style="width:100%"> -->
              <a-col :lg="12"
                     :md="24"
                     class="visit-count-wrapper"
                     style="border-right:1px solid #ddd;border-bottom:1px solid #ddd;">
                <div class="u-chart-title u-chart-subTitle">政策保险完成比例（%）</div>
                <CompleteRateChart ref="completeRateChart2"
                                   :id="'completeRateChart2'" />
              </a-col>

              <a-col :lg="12"
                     :md="24"
                     class="visit-count-wrapper"
                     style="border-bottom:1px solid #ddd;">
                <div class="u-chart-title u-chart-subTitle">农户/新型经营主体投保情况</div>
                <NewSubjectChart ref="newSubjectChart1"
                                 :id="'newSubjectChart1'" />
              </a-col>
              <!-- </a-row>
            <a-row :gutter="8"
                   class="count-info" style="width:100%"> -->
              <a-col :lg="12"
                     :md="24"
                     class="visit-count-wrapper"
                     style="border-right:1px solid #ddd">
                <div class="u-chart-title u-chart-subTitle">各保险公司承保情况(亩)</div>
                <!-- <div id="provinceAcceptInsureChart"></div> -->
                <ByInsuranceChart ref="ByInsuranceChart1"
                                  :id="'ByInsuranceChart1'" />
              </a-col>

              <a-col :lg="12"
                     :md="24"
                     class="visit-count-wrapper">
                <div class="u-chart-title u-chart-subTitle">各保险公司保费支付情况(元)</div>
                <!-- <div id="provinceInsurancePayChart"></div> -->
                <ProvinceInsurancePayChart ref="provinceInsurancePayChart1"
                                           :id="'provinceInsurancePayChart1'" />
              </a-col>
              <!-- </a-row> -->
            </a-col>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <div v-else>
      <!-- <a-row :gutter="8"
             class="count-info">
        <a-col :lg="8"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">政策保险完成比列(%)</div>

            <CompleteRateChart ref="completeRateChart3"
                               :id="'completeRateChart3'" />
          </a-card>
        </a-col>
        <a-col :lg="8"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各保险公司三年投保面积(亩)

            </div>
            <ByInsuranceChart ref="ByInsuranceChart2"
                              :id="'ByInsuranceChart2'" />
          </a-card>
        </a-col>
        <a-col :lg="8"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各保险公司保费支付情况(元)</div>
            <ProvinceInsurancePayChart ref="provinceInsurancePayChart2"
                                       :id="'provinceInsurancePayChart2'" />
          </a-card>
        </a-col>
      </a-row>

      <a-row :gutter="8"
             class="count-info">
        <a-col :lg="8"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">农户/新型经营主体投保情况</div>
            <NewSubjectChart ref="newSubjectChart2"
                             :id="'newSubjectChart2'" />

          </a-card>
        </a-col>
        <a-col :lg="16"
               :md="24"
               class="visit-count-wrapper">
          <a-card class="visit-count">
            <div class="u-chart-title">各乡/镇投保面积情况</div>
            <CityInsuranceChart ref="countryInsuranceChart"
                                :id="'countryInsuranceChart'" />
          </a-card>
        </a-col>
      </a-row> -->
    </div>
  </div>
</template>
<script>
import HeadInfo from '@/views/common/HeadInfo'
import { mapState } from 'vuex'
import moment from 'moment'
import echarts from 'echarts'
import AreaPercentageChart from '@/components/homechart/AreaPercentageChart' // 各险种投保面积占比(%)
import CompleteRateChart from '@/components/homechart/CompleteRateChart' // 政策保险完成比列(%)
import ProvinceInsuredChart from '@/components/homechart/ProvinceInsuredChart' // 全省历年投保情况分析（亩）
import CityInsuranceChart from '@/components/homechart/CityInsuranceChart' // 各地市投保情况（亩）
import ThreeYearAreasChart from '@/components/homechart/ThreeYearAreasChart' // 各保险公司三年投保面积（亩）
import ProvinceInsurancePayChart from '@/components/homechart/ProvinceInsurancePayChart' // 各保险公司保费支付情况(元)
import ByInsuranceChart from '@/components/homechart/ByInsuranceChart' // 各保险公司承保情况（亩）
import NewSubjectChart from '@/components/homechart/NewSubjectChart' // 农户/新型经营主体投保情况
import MapChart from '@/components/homechart/MapChart'

moment.locale('zh-cn') // 全国地图

export default {
  name: 'HomePage1',
  components: {
    HeadInfo,
    MapChart,
    AreaPercentageChart,
    CompleteRateChart,
    ProvinceInsuredChart,
    CityInsuranceChart,
    ThreeYearAreasChart,
    ProvinceInsurancePayChart,
    ByInsuranceChart,
    NewSubjectChart
  },
  data () {
    return {
      level: this.$store.state.account.user.level,
      sumItem: {}, // 合计
      topItem: [], // 头部项目
      topItem1: [], // 固定项目
      topItem2: [], // 其余项目
      areaPercentageData: {}, // 各险种投保面积占比数据
      completeRateData1: {}, // 政策保险完成比例(%) 市
      provinceInsuredData: {}, // 全省历年投保情况分析(亩)
      cityInsuranceData: {}, // 各地市投保情况排名
      threeYearAreasData: {}, // 各保险公司三年承保情况(亩)
      completeRateData2: {}, // 各险种投保面积占比(%)
      newSubjectData1: {}, // 农户/新型经营主体投保情况
      byInsuranceData1: {}, // 各保险公司承保情况（亩）市
      provinceInsurancePayData1: {}, // 各保险公司保费支付情况(元)市
      // /////////////////////////////////////////////
      completeRateData3: {}, // 政策保险完成比例(%) 乡镇
      byInsuranceData2: {}, // 各保险公司承保情况（亩）乡
      provinceInsurancePayData2: {}, // 各保险公司保费支付情况(元)乡
      newSubjectData2: {}, // 农户/新型经营主体投保情况
      countryInsuranceData: {} // 各乡/镇投保面积情况
    }
  },
  computed: {
    ...mapState({
      multipage: state => state.setting.multipage,
      user: state => state.account.user
    }),
    avatar () {
      return `static/avatar/${this.user.avatar}`
    }
  },
  methods: {
    // scrollCard(e){
    //   console.log(e)

    // },
    // 动态字体颜色
    dynamicStateClassName (index) {
      return 'topItemColor' + (index + 1)
    },
    // 动态标题框颜色
    dynamicStateRoundBg (index) {
      return 'round-bg' + (index + 2)
    },
    // 动态加载图片
    dynamicStateImg (index) {
      if (index === 0) {
        return require('@/assets/images/home-img/icon-rice.png')
      } else if (index === 1) {
        return require('@/assets/images/home-img/icon-corn.png')
      } else if (index === 2) {
        return require('@/assets/images/home-img/icon-beans.png')
      } else {
        return require('@/assets/images/home-img/icon-wheat.png')
      }
    },
    getMapByPlantType () {
      this.$get('/statisticsBase/getMapByPlantType', {
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || '',
        year: moment().format('YYYY')
      })
        .then(r => {
          let data = r.data.data
          if (data.length <= 0) return
          // 取每个险种及合计信息
          let newData = []
          data.map(item => {
            if (item.plantTypeName.indexOf('水稻') != -1) {
              newData[0] = item
            } else if (item.plantTypeName.indexOf('玉米') != -1) {
              newData[1] = item
            } else if (item.plantTypeName.indexOf('大豆') != -1) {
              newData[2] = item
            } else if (item.plantTypeName.indexOf('小麦') != -1) {
              newData[3] = item
            }
          })

          let sumItem = {
            cbAcreage: newData.reduce((prev, cur) => cur.cbAcreage + prev, 0),
            personCount: newData.reduce((prev, cur) => cur.personCount + prev, 0)
          }
          this.sumItem = sumItem

          this.topItem = [...newData]
          // 头部数据第一组topItem1,第二组topItem2
          if (this.topItem.length <= 3) {
            this.topItem1 = [...this.topItem]
            this.topItem2 = []
          }
          // 头部数据第一组topItem1,第二组topItem2
          if (this.topItem.length > 3) {
            this.topItem1 = this.topItem.slice(0, 3)
            // mid为第二组topItem2到结束
            let mid = this.topItem.slice(3)
            /* 每一组四个，计算出除固定的还有几组 */
            let forLength = Math.floor(mid.length % 4) === 0 ? Math.floor(mid.length / 4) : Math.floor(mid.length / 4) + 1
            for (let m = 0; m < forLength; m++) {
              this.topItem2[m] = mid.slice(m, m + 4)
            }
          }

          if (this.level > 3) return
        })
        .catch(e => {
          // console.log('err:', e);
        })
    },
    // 各险种投保面积占比(%)
    getInsuranceAcreageRatio () {
      this.$get('/statisticsBase/getInsuranceAcreageRatio', {
        year: moment().format('YYYY'),
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || ''
      })
        .then(r => {
          let data = r.data.data
          if (data && data.source.length > 0) {
            this.areaPercentageData = {
              chartHeight: 240,
              date: data.source[0].createDate,
              source: data.source
            }
          } else {
            this.areaPercentageData = {
              chartHeight: 240,
              date: '',
              source: ''
            }
          }
          this.$refs.areaPercentageChart.initMap(this.areaPercentageData)
        })
        .catch(() => { })
    },
    // 政策保险完成比例(%)
    getInsuranceCompleteRatio () {
      this.$get('/statisticsBase/getInsuranceCompleteRatio', {
        year: moment().format('YYYY'),
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || ''
      })
        .then(r => {
          let data = r.data.data
          // console.log(data)
          if (data && data.dataset.length > 0) {
            this.completeRateData1 = {
              // chartHeight: 240,
              date: data.dataset[0].source[0].createDate,
              dataset: data.dataset
            }
          } else {
            this.completeRateData1 = {
              // chartHeight: 240,
              date: '',
              dataset: [{ source: [] }, { source: [] }, { source: [] }, { source: [] }]
            }
          }
          this.$refs.completeRateChart1.initMap(this.completeRateData1)
        })
        .catch(() => { })
    },
    getMapByInRecentYears () {
      // 各保险公司三年承保情况
      this.$get('/statisticsBase/getMapByInRecentYears', {
        yearName: moment().format('YYYY'),
        plantTypeName: '',
        province: this.$store.state.account.user.province || '230000000000'
      })
        .then(r => {
          let data = r.data.data
          if (data.length <= 0) return
          let date = data[0].createDate
          let source = data.map(item => {
            let newItem = {}
            for (var p in item) {
              if (p === 'insurance') {
                newItem[p] = item[p]
              } else if (p !== 'insurance' && p !== 'createDate') {
                newItem[p + '年'] = item[p]
              }
            }
            return newItem
          })

          let dimensions = Object.keys(source[0])

          let key = dimensions[0]
          dimensions[0] = dimensions[dimensions.length - 1]
          dimensions[dimensions.length - 1] = key
          this.threeYearAreasData = {
            date,
            dimensions,
            source
          }
          this.$refs.threeYearAreasChart.initMap(this.threeYearAreasData)
        })
        .catch(() => { })
    },
    getMapByOverYear () {
      // 全省历年投保情况分析
      this.$get('/statistics/statisticsBase/getMapByOverYear', {
        year: moment().format('YYYY'),
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || ''
      })
        .then(r => {
          let data = r.data.data
          this.provinceInsuredData = {
            date: data.date,
            dimensions: data.typelist,
            source: data.dataList
          }
          this.$refs.provinceInsuredChart.initMap(this.provinceInsuredData)
        })
        .catch(() => { })
    },
    getMapByCity () {
      // 各地市投保情况排名
      this.$get('/statisticsBase/getMapByCity', {
        year: moment().format('YYYY'),
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || ''
      })
        .then(r => {
          let data = r.data.data
          this.cityInsuranceData = {
            date: data.date,
            dimensions: data.typelist,
            source: data.dataList
          }
          this.$refs.cityInsuranceChart.initMap(this.cityInsuranceData)
        })
        .catch(() => { })
    },
    getCbAcreage (params) {
      // 各地区投保情况-联动
      this.$get('/statisticsBase/getCbAcreage', Object.assign({ year: moment().format('YYYY') }, { ...params }))
        .then(r => {
          let data = r.data.data
          let companyCbAcreage = data.companyCbAcreage // 各保险公司承保情况图表
          let companyPay = data.companyPay // 各保险公司保费支付情况
          let depOrIndCbAcreage = data.depOrIndCbAcreage // 农户/新型经营主体投保情况
          let insuranceCbAcreage = data.insuranceCbAcreage // 险种完成比例图表数据
          // 政策保险完成比例（%）
          if (insuranceCbAcreage && insuranceCbAcreage.source.length > 0) {
            let insuranceCbSource = []
            insuranceCbAcreage.source.map(item => {
              let insuranceCbItem = []
              insuranceCbItem.push({ type: item.plantTypeName, labelValue: item.cbAcreage })
              insuranceCbItem.push({ type: '未完成', labelValue: item.unPlantNum })
              insuranceCbSource.push({ source: insuranceCbItem })
            })
            this.completeRateData2 = {
              chartHeight: 240,
              date: insuranceCbAcreage.date,
              dataset: insuranceCbSource
            }
          } else {
            this.completeRateData2 = {
              chartHeight: 240,
              date: '',
              dataset: [{ source: [] }, { source: [] }]
            }
          }
          this.$refs.completeRateChart2.initMap(this.completeRateData2)
          // 农户/新型经营主体投保情况
          if (depOrIndCbAcreage && depOrIndCbAcreage.source.length > 0) {
            this.newSubjectData1 = {
              chartHeight: 240,
              date: depOrIndCbAcreage.date,
              dataset: [
                {
                  source: [
                    { type: '非独立投保户数', labelValue: depOrIndCbAcreage.source[0].depPersonCount },
                    { type: '独立投保户数', labelValue: depOrIndCbAcreage.source[0].indPersonCount }
                  ]
                },
                {
                  source: [
                    { type: '非独立投保面积', labelValue: depOrIndCbAcreage.source[0].depCbAcreage },
                    { type: '独立投保面积', labelValue: depOrIndCbAcreage.source[0].indCbAcreage }
                  ]
                }
              ]
            }
          } else {
            this.newSubjectData1 = {
              chartHeight: 240,
              date: '',
              dataset: [
                {
                  source: []
                },
                {
                  source: []
                }
              ]
            }
          }
          this.$refs.newSubjectChart1.initMap(this.newSubjectData1)

          // 各保险公司承保情况图表
          if (companyCbAcreage && companyCbAcreage.source.length > 0) {
            this.ByInsuranceData1 = {
              chartHeight: 240,
              dataZoom: companyCbAcreage.source.length > 3,
              date: companyCbAcreage.date,
              dataset: companyCbAcreage
            }
          } else {
            this.ByInsuranceData1 = {
              chartHeight: 240,
              date: '',
              dataset: {
                dimensions: [''],
                source: []
              }
            }
          }
          this.$refs.ByInsuranceChart1.initMap(this.ByInsuranceData1)

          // 各保险公司保费支付情况
          if (companyPay && companyPay.source.cbAcreageOk.length > 0) {
            let cbAcreage = companyPay.source.cbAcreage.map(item => {
              delete item.createDate
              return {
                headCompanyName: item.headCompanyName,
                中央财政应付: item['中央财政'],
                省财政应付: item['省财政'],
                县财政应付: item['县财政'],
                个人应付: item['个人']
              }
              return item
            })
            // console.log('cbAcreage:', cbAcreage);
            let cbAcreageOk = companyPay.source.cbAcreageOk.map(item => {
              delete item.createDate, delete item.headCompanyName
              return {
                中央财政已付: item['中央财政'],
                省财政已付: item['省财政'],
                县财政已付: item['县财政'],
                个人已付: item['个人']
              }
            })
            let companyPaySource = []
            for (let i = 0; i < cbAcreage.length; i++) {
              let item = Object.assign(cbAcreage[i], cbAcreageOk[i])
              companyPaySource.push(item)
            }
            this.provinceInsurancePayData1 = {
              chartHeight: 240,
              date: companyPay.date,
              dataZoom: companyPaySource.length > 4,
              dataset: {
                dimensions: ['headCompanyName', '中央财政应付', '省财政应付', '县财政应付', '个人应付', '中央财政已付', '省财政已付', '县财政已付', '个人已付'],
                source: companyPaySource
              }
            }
          } else {
            this.provinceInsurancePayData1 = {
              chartHeight: 240,
              date: ' ',
              dataset: {
                dimensions: [''],
                source: []
              }
            }
            // console.log(this.provinceInsurancePayData1);
          }

          this.$refs.provinceInsurancePayChart1.initMap(this.provinceInsurancePayData1)
        })
        .catch(() => { })
    },
    handleMapChartClick (backParams) {
      // console.log('父backParams:', backParams);
      let level = backParams.level
      // console.log('level:', level);
      let queryparams = {}
      if (level === 0) {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: '',
          county: ''
        }
      } else if (level === 1) {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: backParams.value + '000000',
          county: ''
        }
      } else {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: '',
          county: backParams.value + '000000'
        }
      }
      this.getCbAcreage(queryparams)
      // console.log(code, level)
    },
    resizeCountry () {
      // 重置区县图表大小
      this.$refs.areaPercentageChart.listenResize()
      // 政策保险完成比列(%)
      this.$refs.completeRateChart1.initMap(this.completeRateData1)
      this.$refs.completeRateChart1.listenResize()
      // 全省历年投保情况分析(亩)
      this.$refs.provinceInsuredChart.listenResize()
      // 各地市投保情况排名
      this.$refs.cityInsuranceChart.initMap(this.cityInsuranceData)
      this.$refs.cityInsuranceChart.listenResize()
      // 各保险公司三年承保情况(亩)
      this.$refs.threeYearAreasChart.listenResize()
      // 各险种投保面积占比(%)
      this.$refs.completeRateChart2.initMap(this.completeRateData2)
      this.$refs.completeRateChart2.listenResize()
      // 农户/新型经营主体投保情况 市
      this.$refs.newSubjectChart1.initMap(this.newSubjectData1)
      this.$refs.newSubjectChart1.listenResize()
      // 各保险公司承保情况（亩）
      this.$refs.ByInsuranceChart1.initMap(this.ByInsuranceData1)
      this.$refs.ByInsuranceChart1.listenResize()
      // 各保险公司保费支付情况(元)
      this.$refs.provinceInsurancePayChart1.initMap(this.provinceInsurancePayData1)
      this.$refs.provinceInsurancePayChart1.listenResize()
    },
    // resizeVillages () {
    //   //重置乡镇图表大小
    //   /**
    //         * 乡镇统计
    //         */
    //   //政策保险完成比列(%)乡
    //   this.$refs.completeRateChart3.initMap(this.completeRateData3)
    //   this.$refs.completeRateChart3.listenResize()
    //   //农户/新型经营主体投保情况乡
    //   this.$refs.newSubjectChart2.initMap(this.newSubjectData2)
    //   this.$refs.newSubjectChart2.listenResize()
    //   // 各乡/镇投保面积情况
    //   this.$refs.countryInsuranceChart.initMap(this.countryInsuranceData)
    //   this.$refs.countryInsuranceChart.listenResize()
    //   //各保险公司保费支付情况(元)
    //   this.$refs.provinceInsurancePayChart2.initMap(this.provinceInsurancePayData2)
    //   this.$refs.provinceInsurancePayChart2.listenResize()
    //   //各保险公司三年投保面积（亩）
    //   this.$refs.ByInsuranceChart2.initMap(this.ByInsuranceData2)
    //   this.$refs.ByInsuranceChart2.listenResize()

    // },
    initCountry () { },
    initVillage () {
      // 初始化乡镇图表

      // 政策保险完成比例（%）县乡
      this.completeRateData3 = {
        legend: ['水稻政策性保险', '大豆政策性保险', '玉米政策性保险', '未完成'],
        series: [
          {
            name: '水稻政策保险完成比列(%)',
            type: 'pie',
            radius: ['46%', '60%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 185465,
                name: '水稻政策性保险',
                itemStyle: {
                  color: '#1a8dee'
                },
                tooltip: {
                  formatter: '{a}</br>已完成：{c} ({d}%)'
                }
              },

              {
                value: 23000,
                name: '未完成',
                itemStyle: {
                  color: '#48ebd0'
                }
              }
            ]
          },
          {
            name: '大豆政策保险完成比列(%)',
            type: 'pie',
            radius: ['27%', '42%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 182365,
                name: '大豆政策性保险',
                itemStyle: {
                  color: '#73b4f8'
                },
                tooltip: {
                  formatter: '{a}</br>已完成{c} ({d}%)'
                }
              },

              {
                value: 25000,
                name: '未完成',
                itemStyle: {
                  color: '#48ebd0'
                }
              }
            ]
          },
          {
            name: '玉米政策保险完成比列(%)',
            type: 'pie',
            radius: [0, '22%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'inside',
              fontSize: 16,
              formatter (val) {
                return val.value
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 1000000,
                name: '玉米政策性保险',
                itemStyle: {
                  color: '#13cdcc'
                },
                tooltip: {
                  formatter: '{a}</br>已完成{c} ({d}%)'
                }
              },

              {
                value: 1500000,
                name: '未完成',
                itemStyle: {
                  color: '#48ebd0'
                }
              }
            ]
          }
        ]
      }
      //  this.$refs.completeRateChart3.initMap(this.completeRateData1)
      // 各保险公司三年投保面积（亩）
      this.ByInsuranceData2 = {
        dataset: {
          dimensions: ['insurance', '水稻政策性保险', '大豆政策性保险', '玉米政策性保险'],
          source: [
            { insurance: '阳光保险', 水稻政策性保险: 1000, 大豆政策性保险: 1500, 玉米政策性保险: 1200 },
            { insurance: '太平洋保险', 水稻政策性保险: 2000, 大豆政策性保险: 1800, 玉米政策性保险: 1600 },
            { insurance: '安信保险', 水稻政策性保险: 5000, 大豆政策性保险: 2000, 玉米政策性保险: 3000 },
            { insurance: '平安保险', 水稻政策性保险: 10000, 大豆政策性保险: 5000, 玉米政策性保险: 8000 }
          ]
        }
      }
      this.$refs.ByInsuranceChart2.initMap(this.ByInsuranceData2)
      // 各保险公司保费支付情况（元）
      this.provinceInsurancePayData2 = {
        date: '',
        dimensions: ['organization', '中央财政', '省财政', '县财政', '个人'],
        source: [
          { organization: '阳光保险', 中央财政: 1000, 省财政: 1500, 县财政: 1200, 个人: 1289, 中央财政: 1000, 省财政: 1500, 县财政: 1200, 个人: 1289 },
          { organization: '太平洋保险', 中央财政: 2000, 省财政: 1800, 县财政: 1600, 个人: 1000, 中央财政: 2000, 省财政: 1800, 县财政: 1600, 个人: 1000 },
          { organization: '安信保险', 中央财政: 5000, 省财政: 2000, 县财政: 3000, 个人: 1489, 中央财政: 5000, 省财政: 2000, 县财政: 3000, 个人: 1489 },
          { organization: '华安保险', 中央财政: 10000, 省财政: 5000, 县财政: 8000, 个人: 1600, 中央财政: 10000, 省财政: 5000, 县财政: 8000, 个人: 1600 }
        ]
      }
      this.$refs.provinceInsurancePayChart2.initMap(this.provinceInsurancePayData2)
      // 农户/新型经营主体投保情况 乡
      this.newSubjectData2 = {
        legend: ['非独立投保户数', '独立投保户数', '非独立投保面积', '独立投保面积'],
        series: [
          {
            name: '非独立独立投保户数',
            type: 'pie',
            radius: ['46%', '60%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 185465,
                name: '非独立投保户数',
                itemStyle: {
                  color: '#1a8dee'
                },
                tooltip: {
                  formatter: '{a}</br>已完成：{c} ({d}%)'
                }
              },

              {
                value: 23000,
                name: '独立投保户数',
                itemStyle: {
                  color: '#46f383'
                }
              }
            ]
          },
          {
            name: '非独立独立投保面积',
            type: 'pie',
            radius: ['27%', '42%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 182365,
                name: '非独立投保面积',
                itemStyle: {
                  color: '#58bdf4'
                },
                tooltip: {
                  formatter: '{a}</br>已完成{c} ({d}%)'
                }
              },

              {
                value: 25000,
                name: '独立投保面积',
                itemStyle: {
                  color: '#48ebd0'
                }
              }
            ]
          }
        ]
      }
      this.$refs.newSubjectChart2.initMap(this.newSubjectData2);
      // 各乡/镇投保面积情况
      (this.countryInsuranceData = {
        dimensions: ['area', '确权面积', '水稻政策性保险', '玉米政策性保险', '大豆政策性保险'],
        source: [
          { area: '香兰镇', 确权面积: 1000, 水稻政策性保险: 1500, 玉米政策性保险: 1200, 大豆政策性保险: 1200 },
          { area: '汤原镇', 确权面积: 2000, 水稻政策性保险: 1800, 玉米政策性保险: 1600, 大豆政策性保险: 1000 },
          { area: '吉祥乡', 确权面积: 5000, 水稻政策性保险: 2000, 玉米政策性保险: 3000, 大豆政策性保险: 1489 },
          { area: '进乡乡', 确权面积: 10000, 水稻政策性保险: 2000, 玉米政策性保险: 3000, 大豆政策性保险: 1489 },
          { area: '太平川乡', 确权面积: 8000, 水稻政策性保险: 5000, 玉米政策性保险: 8000, 大豆政策性保险: 1600 }
        ]
      }),
      this.$refs.countryInsuranceChart.initMap(this.countryInsuranceData)
    }
  },
  created () {
    if (this.level <= 3) {
      // 2保险计划情况，各保险投保面积比，政策保险完成比例
      this.getMapByPlantType()
      // 各险种投保面积占比(%)
      this.getInsuranceAcreageRatio()
      // 政策保险完成比例
      this.getInsuranceCompleteRatio()
      // 各保险公司三年承保情况
      this.getMapByInRecentYears()
      // 全省历年投保情况分析
      this.getMapByOverYear()
      // 各地市投保情况排名
      this.getMapByCity()
      // 黑龙江省各区县投保情况
      this.getCbAcreage({
        province: this.$store.state.account.user.province || '230000000000',
        city: this.$store.state.account.user.city || '',
        county: this.$store.state.account.user.county || ''
      })
    }
  },
  mounted () {
    // 重置图表大小
    window.addEventListener('resize', () => {
      if (this.level <= 3) {
      //  省市统计
        this.resizeCountry()
      } else {
        // this.resizeVillages()
      }
    })

    // if (this.level <= 3) {
    //   this.initCountry()
    // } else {

    //   this.initVillage()
    // }
  },
  beforeDestroy () {
    // window.removeEventListener("resize");
  }
}
</script>
<style lang="less">
// 水稻政策性保险
.home-page {
  .white-card {
    .topItemColor1 {
      color: rgba(26, 141, 238, 1) !important;
      font-weight: 700;
    }
  }
}
// 大豆政策性保险
.home-page {
  .white-card {
    .topItemColor2 {
      color: #12cdcc !important;
      font-weight: 700;
    }
  }
}

// 玉米政策性保险
.home-page {
  .white-card {
    .topItemColor3 {
      color: #00d5b2 !important;
      font-weight: 700;
    }
  }
}

// 小麦政策性保险
.home-page {
  .white-card {
    .topItemColor4 {
      color: rgba(255, 144, 35, 1) !important;
      font-weight: 700;
    }
  }
}
.home-page {
  .part-2 {
    padding: 0 !important;
    // height: 550px;
    border-left: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
    .visit-count-wrapper.ant-col-12 {
      padding: 0;
      display: flex;
      height: 240px;
      flex-direction: column;
      :nth-child(2) {
        flex-grow: 1;
      }
    }
  }

  .white-card {
    background: #fff;
    border-radius: 8px;
    padding: 10px 30px;
    min-height: 90px;
    overflow: hidden;
    .ant-card-body {
      min-height: 90px;
      display: flex;
      justify-content: space-between;
    }
    .left-content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      div {
        margin: 2px 0;
        text-align: left;
        span:nth-child(2) {
          // font-size: 18px;
          // color: #000;
          // padding-left: 5px;
          font-size: 20px;
          padding-left: 5px;
          font-weight: bold;
        }
      }
    }
    .right-content {
      line-height: 100%;
      width: 66px;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
  .round-bg {
    border-radius: 20px;
    color: rgba(26, 141, 238, 1);
    background: rgba(26, 141, 238, 0.1);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    text-align: center;
  }
  .round-bg2 {
    border-radius: 20px;
    color: rgba(26, 141, 238, 1);
    background: rgba(26, 141, 238, 0.1);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    text-align: center;
    color: rgba(70, 173, 229, 1);
    background: rgba(70, 173, 229, 0.1);
  }
  .round-bg3 {
    border-radius: 20px;
    color: rgba(26, 141, 238, 1);
    background: rgba(26, 141, 238, 0.1);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    text-align: center;
    color: rgba(18, 205, 204, 1);
    background: rgba(18, 205, 204, 0.1);
  }
  .round-bg4 {
    border-radius: 20px;
    color: rgba(26, 141, 238, 1);
    background: rgba(26, 141, 238, 0.1);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    text-align: center;
    color: rgba(0, 213, 178, 1);
    background: rgba(0, 213, 178, 0.1);
  }
  .round-bg5 {
    border-radius: 20px;
    color: rgba(26, 141, 238, 1);
    background: rgba(26, 141, 238, 0.1);
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    text-align: center;
    color: rgba(255, 144, 35, 1);
    background: rgba(255, 144, 35, 0.1);
  }
  /deep/ .not-menu-page {
    background: none !important;
    padding: 0 !important;
  }
  /deep/ .ant-card {
    margin-left: 5px;
    margin-right: 3px;
    margin-bottom: 16px;
  }
  /deep/ .ant-card-body {
    padding: 0 !important;
  }
  .u-chart-title {
    width: 100%;
    border-bottom: 1px solid #ddd;
    padding: 8px;
    margin-bottom: 20px;
    text-align: center;
    color: #333;
    font-size: 15px;
    font-weight: bold;
  }
  .u-chart-subTitle {
    font-size: 14px;
    font-weight: normal;
    color: #333;
    border-bottom: none;
    margin-bottom: 10px;
  }
  .visit-count {
    .u-chart-content {
      // width: 380px;
      margin: 0 auto;
    }
  }
}

/* 轮播 */
.home-page /deep/ .scorll-row {
  margin-bottom: 10px;
}
.home-page /deep/ .scorll-row .ant-card {
  margin-bottom: 0;
}
.ant-carousel .slick-prev,
.ant-carousel .slick-next {
  top: 47% !important;
}
.ant-carousel .slick-slide {
  text-align: center;
  overflow: hidden;
}
.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  color: #999 !important;
  opacity: 0.6;
}
.ant-carousel .custom-slick-arrow i {
  font-size: 1.6rem;
}
.ant-carousel .custom-slick-arrow:before {
  display: none;
}
.ant-carousel .custom-slick-arrow:hover {
  opacity: 1;
}
.ant-carousel .slick-slide h3 {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage1.vue